import { Button, Form, Modal } from 'antd';
import Title from 'antd/es/typography/Title';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { DarkText, FlexWrapper } from '../../../theme/common_style';
import { useLocation } from 'react-router-dom';
import {
  updateProjectInchargeApi,
  updateProjectManagerApi,
  updateProjectTeamApi
} from '../../../redux/project/apiRoute';
import { toast } from 'react-toastify';
import { AvatarMultiSelect, AvatarSelect } from '../../../components/common/AvatarSelect';
import userProjectAssigneelist from '../../../hooks/userProjectAssigneelist';

const AddMemeberModal = ({ open, setOpen, type, selectedUser, handleListing, filterOption }) => {
  const [form] = Form.useForm();
  const { loading: employeeLoading, options: employeeOption } = userProjectAssigneelist();
  const location = useLocation();
  const { id } = location.state || {};
  const [loading, setLoading] = useState(false);
  const isEdit = selectedUser?.length > 0;

  const close = () => {
    setOpen(false);
    form.resetFields();
  };

  useEffect(() => {
    if (selectedUser && !employeeLoading && employeeOption?.length > 0) {
      let ids;

      if (type === 'Team Member') {
        ids = selectedUser?.map((el) => el?.emp_id?.id);
      } else {
        ids = selectedUser?.[0]?.emp_id?.id;
      }

      form.setFieldsValue({
        memberIds: ids
      });
    }
  }, [selectedUser, form, open, employeeLoading, employeeOption, type]);

  const handleFinish = async (values) => {
    try {
      setLoading(true);
      const payload = {
        memberIds:
          type === 'Team Member' ? values?.memberIds : values?.memberIds ? [values?.memberIds] : []
      };
      let res;
      if (type === 'Project Incharge') {
        res = await updateProjectInchargeApi(payload, id);
      } else if (type === 'Project Manager') {
        res = await updateProjectManagerApi(payload, id);
      } else {
        res = await updateProjectTeamApi(payload, id);
      }
      if (res?.statusCode === 200) {
        toast.success(res?.message || 'Successfully updated');
        close();
        handleListing();
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (err) {
      toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={close}
      centered
      style={{ maxWidth: '90%', width: '350px' }}
      footer={null}>
      <Title style={{ margin: 0, textAlign: 'start' }} level={4}>
        {isEdit ? 'Update' : 'Add'} {type}
      </Title>
      <Form autoComplete="off" form={form} onFinish={handleFinish}>
        <FlexWrapper direction="column" gap="10px" margin="25px 0 6px" width="100%" align="start">
          <DarkText weight="400">{type}</DarkText>
          <Form.Item
            name="memberIds"
            rules={[
              {
                required: isEdit ? false : true,
                message: `Please select ${type}`
              }
            ]}
            style={{ width: '100%' }}>
            {type === 'Team Member' ? (
              <AvatarMultiSelect
                options={
                  filterOption?.length > 0
                    ? employeeOption?.filter(
                        (item) => !filterOption?.find((el) => el?.emp_id?.id == item?.value)
                      )
                    : employeeOption
                }
                placeholder={`Select ${type}`}
                loading={employeeLoading}
                isEmp={true}
              />
            ) : (
              <AvatarSelect
                options={
                  filterOption?.length > 0
                    ? employeeOption?.filter(
                        (item) => !filterOption?.find((el) => el?.emp_id?.id == item?.value)
                      )
                    : employeeOption
                }
                placeholder={`Select ${type}`}
                loading={employeeLoading}
                isEmp={true}
              />
            )}
          </Form.Item>
        </FlexWrapper>
        <FlexWrapper justify="end">
          <Button
            loading={loading}
            style={{ width: '140px' }}
            prefixCls="antCustomBtn"
            onClick={form.submit}>
            {isEdit ? 'Update' : 'Add'}
          </Button>
        </FlexWrapper>
      </Form>
    </Modal>
  );
};

AddMemeberModal.propTypes = {
  type: PropTypes.string.isRequired,
  selectedUser: PropTypes.any,
  handleListing: PropTypes.func,
  filterOption: PropTypes.array,
  open: PropTypes.bool,
  setOpen: PropTypes.func
};

export default AddMemeberModal;
